import { IconButton, Tooltip } from "@mui/material";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import type { TransactionListDto } from "../api/types";

interface CreateRuleButtonProps {
  transaction: TransactionListDto;
  onCreateRule: (tx: TransactionListDto) => void;
  size?: "small" | "medium" | "large";
}

export const CreateRuleButton = ({
  transaction,
  onCreateRule,
  size = "small",
}: CreateRuleButtonProps) => {
  return (
    <Tooltip title="Create Rule">
      <IconButton
        aria-label="Create Rule"
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          onCreateRule(transaction);
        }}
      >
        <PlaylistAddIcon fontSize={size === "small" ? "small" : "medium"} />
      </IconButton>
    </Tooltip>
  );
};
